import { render, staticRenderFns } from "./ReportsTab.vue?vue&type=template&id=f1f81410&scoped=true&"
import script from "./ReportsTab.vue?vue&type=script&lang=ts&"
export * from "./ReportsTab.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsTab.vue?vue&type=style&index=0&id=f1f81410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f81410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
